import { IconName, Size } from './types'

export const DEBUG_MODE = false

export const AVATAR_DISPLAY_SIZE = {
  small: { width: '55px', height: '55px' },
  medium: { width: '90px', height: '90px' },
  large: { width: '250px', height: '250px' },
  xlarge: { width: '300px', height: '300px' },
} as Record<Size, { width: string; height: string }>

export const APP_ICONS = {
  ANGLE_DOUBLE_LEFT: 'angle double left',
  ANGLE_DOUBLE_RIGHT: 'angle double right',
  ANGLE_DOUBLE_UP: 'angle double up',
  ARROW_RIGHT: 'arrow right',
  BELL: 'bell',
  BUG: 'bug',
  CHART_BAR: 'chart bar',
  CHECK: 'check',
  CHEVRON_LEFT: 'left chevron',
  CHEVRON_RIGHT: 'right chevron',
  CLOSE: 'close',
  COPY_OUTLINE: 'copy outline',
  CREDITCARD_OUTLINE: 'credit card outline',
  CUBE: 'cube',
  DATABASE: 'database',
  DROPDOWN: 'dropdown',
  EYE: 'eye',
  EYE_SLASH: 'eye slash',
  FROWN: 'frown',
  HAND_POINTER: 'hand pointer',
  HOURGLASS_TWO: 'hourglass two',
  IDEA: 'idea',
  INFO: 'info circle',
  KEYBOARD_OUTLINE: 'keyboard outline',
  LOCK: 'lock',
  PICTURE: 'picture',
  QUESTION_CIRCLE: 'question circle',
  RANDOM: 'random',
  SEARCH: 'search',
  SECURITY: 'protect',
  SETTING: 'setting',
  SHARE: 'share',
  SHARE_SQUARE: 'share square',
  SMILE: 'smile',
  STAR: 'star',
  THUMBS_DOWN: 'thumbs down',
  THUMBS_UP: 'thumbs up',
  UNLOCK: 'unlock',
  USER: 'user',
  USER_CIRCLE: 'user circle',
  USER_DELETE: 'user delete',
  USER_PLUS: 'user plus',
  WARNING_SIGN: 'warning sign',
  WRITE: 'write',
} as Record<IconName, string>
